export type AccuracyCount = {
    accurate: number;
    total: number;
};

export type RenderAccuracy = {
    percentage: number;

    assetLoading: {
        images: AccuracyCount;
        fonts: AccuracyCount;
        videos: AccuracyCount;
    };

    frameSeeking: {
        videos: AccuracyCount;
    };
};

export const createEmptyRenderAccuracy = (): RenderAccuracy => ({
    percentage: 100,
    assetLoading: {
        images: { accurate: 0, total: 0 },
        fonts: { accurate: 0, total: 0 },
        videos: { accurate: 0, total: 0 },
    },
    frameSeeking: {
        videos: { accurate: 0, total: 0 },
    },
});

export const computeRenderAccuracyPercentage = (accuracy: RenderAccuracy): number => {
    const { assetLoading, frameSeeking } = accuracy;

    const videoAccurate = frameSeeking.videos.total > 0 ? frameSeeking.videos.accurate : assetLoading.videos.accurate;

    const accurateCount = assetLoading.images.accurate + assetLoading.fonts.accurate + videoAccurate;
    const totalCount = assetLoading.images.total + assetLoading.fonts.total + assetLoading.videos.total;

    return totalCount === 0 ? 100 : Math.round((accurateCount / totalCount) * 100);
};

export const isFullyAccurate = (accuracy: RenderAccuracy): boolean => accuracy.percentage === 100;
